import React, { type ReactElement, type ReactNode } from 'react';
import clsx from 'clsx';
import BackButton from 'atom-components/buttons/common-back-button';

type Props = {
  onBack?(): void;
  footerButtons?: ReactNode;
  className?: string;
};

export default function MainLayoutFooter(props: Props): ReactElement {
  const { onBack, footerButtons, className } = props;

  return (
    <div className={clsx(className, 'main-layout-footer', 'd-flex my-2')}>
      {!!onBack && <BackButton onClick={onBack} />}
      <div className="ms-auto">{footerButtons}</div>
    </div>
  );
}
